<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-4 mt-5 tit-edit">
      <h3>Dados Pessoais</h3>
      <a href="javascript:void(0)" class="btn btn-perfil" @click="$bvModal.show('modalDadosPessoais')">{{ $t('btn.editar') }}</a>
    </div>
    <div class="d-flex align-items-center justify-content-between mt-3">
      <div class="d-flex align-items-center">
        <i class="fas fa-user"></i>
        <div>
          <label for="nome">Nome</label>
          <input type="text" readonly class="form-control-plaintext" id="nome" v-model="dadosPessoais.nome">
        </div>
      </div>
    </div>
    <hr/>
    <div class="d-flex align-items-center justify-content-between mt-3">
      <div class="d-flex align-items-center">
        <i class="fas fa-birthday-cake"></i>
        <div>
          <label for="dtNascimento">Nascimento</label>
          <input type="text" readonly class="form-control-plaintext" id="dtNascimento" v-model="dadosPessoais.dataNascimento">
        </div>
      </div>
    </div>
    <hr/>
    <div class="d-flex align-items-center justify-content-between mt-3">
      <div class="d-flex align-items-center">
        <i class="fas fa-mobile-alt"></i>
        <div>
          <label for="telefone">Telefone</label>
          <input type="text" readonly class="form-control-plaintext" id="telefone" v-model="dadosPessoais.telefone">
        </div>
      </div>
    </div>
    <hr/>
    <div class="d-flex align-items-center justify-content-between mt-3">
      <div class="d-flex align-items-center">
        <i class="fas fa-info"></i>
        <div>
          <label for="info">Informações Adicionais</label>
          <span class="form-control-plaintext" id="telefone" v-html="dadosPessoais.infoExtra"></span>
        </div>
      </div>
    </div>
    <hr/>
    <div class="d-flex align-items-center justify-content-between mt-3" v-if="false">
      <div class="d-flex align-items-center">
        <i class="fas fa-user-md"></i>
        <div>
          <label for="especialidade">Especialidade (atual ou pretendida)</label>
          <input type="text" readonly class="form-control-plaintext" id="especialidade" v-model="dadosPessoais.especialidade">
        </div>
      </div>
    </div>

    <b-modal hide-footer id="modalDadosPessoais" body-class="modal-conteudo pb-4" header-class="">
      <template slot="modal-title">
        <h5 class="modal-title">Dados pessoais</h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12">
            <form-group id="nomeAlteracao" label="Nome" :text="{ required: 'Obrigatório informar o nome' }" :field="$v.dadosPessoaisAlteracao.nome">
              <input type="text" id="nomeAlteracao" class="form-control" placeholder="" v-model="dadosPessoaisAlteracao.nome">
            </form-group>
          </div>
          <div class="col-12 col-md-6">
            <form-group id="nasc" label="Nascimento" :text="{ required: 'Obrigatório informar a data de nascimento', verificarNascimentoDataValida: 'Data de nascimento inválida' }" :field="$v.dadosPessoaisAlteracao.dataNascimento">
              <masked-input placeholder="DD/MM/AAAA" :mask="'##/##/####'" v-model="dadosPessoaisAlteracao.dataNascimento" />
            </form-group>
          </div>
          <div class="col-12 col-md-6">
            <form-group id="tel" label="Telefone" :text="{ required: 'Obrigatório informar o telefone' }" :field="$v.dadosPessoaisAlteracao.telefone">
              <masked-input id="tel" :mask="['(##) ####-####', '(##) #####-####']" v-model="dadosPessoaisAlteracao.telefone" />
            </form-group>
          </div>
          <div class="col-12 col-md-12">
            <form-group id="infoExtra1" label="Informações Adicionais" :field="$v.dadosPessoaisAlteracao.infoExtra">
              <ckeditor :editor="editor" class="ckeditor" :config="editorConfig" v-model="dadosPessoaisAlteracao.infoExtra"></ckeditor>
            </form-group>
          </div>
          <div class="col-12 col-md-12" v-if="false">
            <div class="form-group">
              <label for="nasc">Especialidade (atual ou pretendida)</label>
              <input type="text" class="form-control" placeholder="" v-model="dadosPessoaisAlteracao.especialidade">
            </div>
          </div>
        </div>
        <div class="text-center">
          <button type="button" @click="salvarDadosPessoais" class="btn btn-secondary my-3">Alterar dados pessoais</button>
        </div>
      </form>
    </b-modal>

  </div>
</template>

<script>
import EnderecoAPI from '@/api/endereco-api'
import PerfilAPI from '@/api/perfil-api'
import DateUtils from '@/core/utils/date-utils'
import { mask } from 'vue-the-mask'
import FormGroup from '@/core/components/FormGroup'
import { required } from 'vuelidate/lib/validators'
import MaskedInput from '@/core/components/mask/MaskedInput'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import Swal from 'sweetalert2'

const verificarNascimentoDataValida = dataNascimento => {
  return DateUtils.parse(dataNascimento, 'DD/MM/YYYY').isValid()
}

export default {
  name: 'DadosPessoais',
  components: { MaskedInput, FormGroup },
  directives: { mask },
  props: {
    aluno: Object
  },
  data () {
    return {
      ufs: [],
      dadosPessoais: {},
      dadosPessoaisAlteracao: {},
      editor: ClassicEditor,
      editorConfig: {
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'undo', 'redo']
      }
    }
  },
  validations: {
    dadosPessoaisAlteracao: {
      nome: { required },
      telefone: { required },
      dataNascimento: { required, verificarNascimentoDataValida },
      infoExtra: { }
    }
  },

  mounted () {
    this.dadosPessoaisAlteracao = Object.assign({}, this.aluno)

    EnderecoAPI.listarUF().then(data => {
      this.ufs = data
    })
  },
  watch: {
    aluno: function (aluno) {
      this.dadosPessoais = Object.assign({}, this.aluno)
      this.dadosPessoaisAlteracao = Object.assign({}, this.aluno)
    }
  },

  methods: {
    salvarDadosPessoais: function () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        let dataNascimento
        if (this.dadosPessoaisAlteracao.dataNascimento) {
          dataNascimento = DateUtils.parse(this.dadosPessoaisAlteracao.dataNascimento, 'DD/MM/YYYY')
        }

        const loader = this.$loading.show()

        PerfilAPI
          .atualizarDadosPessoais(this.dadosPessoaisAlteracao.nome, DateUtils.formatDate(dataNascimento), this.dadosPessoaisAlteracao.cpf, this.dadosPessoaisAlteracao.telefone, this.dadosPessoaisAlteracao.infoExtra)
          .then(() => {
            this.dadosPessoais = Object.assign({}, this.dadosPessoaisAlteracao)

            this.$bvModal.hide('modalDadosPessoais')
            loader.hide()
            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: 'Dados editados com sucesso'
            })
          })
      }
    }
  }
}
</script>

<style scoped>

</style>
